import { useCallback, useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Svg, Typography } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { TutorialDialog } from '@/_shared/components/TutorialDialog';
import { TutorialKeys } from '@/_shared/constants';
import { useDialog, useTutorialCheck } from '@/_shared/hooks';
import { TableTrainings } from '../components/TableTrainings';
import { getReportTrainingExportCall } from '../state/api';

export const ReportsTrainingsScreen = () => {
  // eslint-disable-next-line @altermaind/use-translations-scope
  const t = useTranslations('reports');
  const { execute: executeGetReportTrainingExport, loading: loadingGetReportTrainingExport } =
    getReportTrainingExportCall.hook();
  const { openDialog: openDialogReportsTrainingsTutorial } = useDialog('reportsTrainingsTutorial');
  const { setLayout } = useContext(LayoutContext);
  const { hasAlreadySeenTutorial } = useTutorialCheck();

  const slides = [
    {
      title: t('trainings.tutorial.slides.slide1.title'),
      description: t('trainings.tutorial.slides.slide1.description'),
      assetName: 'tutorialReportsTrainingsSlide1',
    },
    {
      title: t('trainings.tutorial.slides.slide3.title'),
      description: t('trainings.tutorial.slides.slide3.description'),
      assetName: 'tutorialReportsTrainingsSlide3',
    },
  ];

  const handleExportClick = useCallback(() => {
    executeGetReportTrainingExport({});
  }, [executeGetReportTrainingExport]);

  useEffect(() => {
    if (!hasAlreadySeenTutorial(TutorialKeys.ReportsTrainings)) {
      openDialogReportsTrainingsTutorial();
    }
  }, [hasAlreadySeenTutorial, openDialogReportsTrainingsTutorial]);

  useEffect(() => {
    setLayout({ title: 'reports' });
  }, [setLayout, t]);

  return (
    <>
      <Typography as='span' variant='h1' mr='xxxs'>
        {t('trainings.pageTitle')}
      </Typography>
      <Box display='flex' justifyContent='flex-end' alignItems='center' mb='s' mt='s'>
        <Button onClick={handleExportClick} disabled={loadingGetReportTrainingExport}>
          <Typography as='span' variant='p2/bold' mr='xxxs'>
            {t('export')}
          </Typography>
          <Svg name='download' fill='primary/text' size='s' />
        </Button>
      </Box>
      <AlertBadge iconName='lightBulb' type='primary' label={t('trainings.alertBadge')} />
      <Box display='flex' flexDirection='column'>
        <TableTrainings />
      </Box>
      <AlertBadge iconName='lightBulb' type='transparent' label={t('trainings.exportBadge')} />
      <TutorialDialog
        translationsKey='reports.trainings.tutorial'
        dialogKey='reportsTrainingsTutorial'
        slides={slides}
      />
    </>
  );
};
